import { AppState } from '../../store';

export const getCurrencySelector = (id: number | string | undefined) => (state: AppState) => {
  if (!id) return null;
  return state.currency[id];
};
